import React, { useEffect, useState, useRef } from "react";
import "./domain.css";

import Aviation from "../../assets/images/avition-domain.png";
import { Link, useSearchParams } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

const AviationDomain = () => {
  const [play, setPlay] = useState(false);

  const vidRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
     AOS.init();
  }, []);

  const handlePlay = () => {
    if (vidRef && vidRef.current) {
      if (vidRef.current.paused) {
        setPlay(true);
        vidRef.current.play();
      } else {
        setPlay(false);
        vidRef.current.pause();
      }
    }
  };

  console.log(play);
  return (
    <>
      <div className="domain-banner aviation">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="content">
            <div className="heading" data-aos="fade-up" data-aos-duration="1500">
              <div className="heading-flex">
                <h2>Aviation</h2>
                <h4>Fidus: Your Trusted Partner in Aviation Training</h4>
                <p>
                  For the past three years, Fidus has been at the forefront of
                  aviation training, delivering high-quality courses tailored to
                  the unique needs of pilots, ground staff, and other aviation
                  professionals. Our team of seasoned professionals ensures that
                  our training programs are not only comprehensive but also
                  relevant and up-to-date with industry standards and
                  regulations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-banner-circle"></div>
        <div className="domain-section-content">
          <div className={play ? "domain-main-img play" : "domain-main-img"}>
            <img src={Aviation} alt="" />
            <div className="domain-opq-dummy">
              <div class="step" onClick={handlePlay}>
                {play ? (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Bold"
                      viewBox="0 0 24 24"
                      width="40"
                      height="40"
                      fill="#37466F"
                    >
                      <path d="M9,17V7a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1Z"></path>
                      <path d="M14,17V7a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1Z"></path>
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Bold"
                      viewBox="0 0 24 24"
                      width="70"
                      height="40"
                      fill="#37466F"
                    >
                      <path d="M9,17.879V6.707A1,1,0,0,1,10.707,6l5.586,5.586a1,1,0,0,1,0,1.414l-5.586,5.586A1,1,0,0,1,9,17.879Z"></path>
                    </svg>
                  </>
                )}

                <div class="ripple"></div>
                <div class="ripple"></div>
                <div class="ripple"></div>
              </div>
            </div>
            <div className="domain-player">
              <video ref={vidRef} controls controlsList="nodownload" muted>
                <source src="https://fidusindia.in/assets2/domains/videos/AviationDomain.mp4" />
              </video>
            </div>
          </div>
          <div className="domain-main" >
            <div className="domain-main-content" data-aos="fade-right" data-aos-duration="1500">
              <h2>Comprehensive Training Solutions</h2>
              <p>
                From pilots seeking to enhance their skills to ground staff
                navigating complex operational challenges, Fidus offers a
                comprehensive range of training solutions to meet diverse needs.
                Our courses cover a wide range of topics, including flight
                operations, safety procedures, regulatory compliance, and
                customer service, empowering aviation professionals to excel in
                their roles and advance their careers.
              </p>
            </div>
          </div>
          <div className="domain-main reverse" >
            <div className="domain-main-content" data-aos="fade-left" data-aos-duration="1500">
              <h2>Customized Approach</h2>
              <p>
                At Fidus, we understand that one size does not fit all when it
                comes to aviation training. That's why we take a customized
                approach to course development, tailoring our programs to the
                specific requirements of each client and learner. Whether you're
                a seasoned pilot or a newcomer to the industry, we have the
                expertise to design a training solution that meets your needs
                and exceeds your expectations.
              </p>
            </div>
          </div>
          <div className="domain-main">
            <div className="domain-main-content" data-aos="fade-right" data-aos-duration="1500">
              <h2>Global Impact</h2>
              <p>
                While our roots may be in India, our impact extends far beyond
                borders. Fidus has proudly served clients from around the world,
                delivering training solutions that transcend geographical
                boundaries. Our customizable and scalable programs are designed
                to meet the needs of international clients, ensuring that
                aviation professionals everywhere have access to the highest
                quality training.
              </p>
              <h4>
                Contact Fidus India today and discover how our eLearning
                solutions can fuel your aviation expertise.
              </h4>
              <Link className="read-more-product" to={"/request"}>
                <span>Contact Us !</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AviationDomain;
